module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showType == _vm.OPERATION_LIST) ? _c('list-render', {
    attrs: {
      "contentId": _vm.contentId,
      "dealId": _vm.dealId,
      "query": _vm.query
    },
    on: {
      "sendParams": _vm.sendParams,
      "setFilterQuery": _vm.setFilterQuery
    }
  }) : (_vm.showType == _vm.OPERATION_PARAMS) ? _c('params-render', {
    attrs: {
      "contentId": _vm.contentId,
      "dealId": _vm.dealId
    },
    on: {
      "saveCallback": _vm.saveCallback
    }
  }) : (_vm.showType == _vm.OPERATION_IFRAME) ? _c('iframe-render', {
    attrs: {
      "contentId": _vm.contentId,
      "dataId": _vm.dataId,
      "dealId": _vm.dealId
    }
  }) : (_vm.showType === _vm.OPERATION_EDIT || _vm.showType === _vm.OPERATION_DETAIL) ? _c('form-render', {
    attrs: {
      "contentId": _vm.contentId,
      "dealId": _vm.dealId,
      "dataId": _vm.dataId,
      "level": _vm.level
    },
    on: {
      "saveCallback": _vm.saveCallback
    }
  }) : (_vm.showType == _vm.OPERATION_SELF) ? _c('self-render', {
    attrs: {
      "iden": _vm.iden
    }
  }) : (_vm.showType == _vm.OPERATION_DEALGROUP) ? _c('deal-group-render', {
    attrs: {
      "contentId": _vm.contentId,
      "dealId": _vm.dealId,
      "dataId": _vm.dataId
    }
  }) : (_vm.showType != 0) ? _c('form-render', {
    attrs: {
      "contentId": _vm.contentId,
      "dealId": _vm.dealId,
      "level": _vm.level
    },
    on: {
      "saveCallback": _vm.saveCallback
    }
  }) : _vm._e(), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07f00c36!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/allRender.vue
// module id = 1763
// module chunks = 2